/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Content } from '../models/content';
import { FastIlsInfo } from '../models/fast-ils-info';
import { GroupsInfo } from '../models/groups-info';
import { Ils } from '../models/ils';
import { ilsControllerAddContentToIls } from '../fn/ils/ils-controller-add-content-to-ils';
import { IlsControllerAddContentToIls$Params } from '../fn/ils/ils-controller-add-content-to-ils';
import { ilsControllerAddPhaseToIls } from '../fn/ils/ils-controller-add-phase-to-ils';
import { IlsControllerAddPhaseToIls$Params } from '../fn/ils/ils-controller-add-phase-to-ils';
import { ilsControllerCountStudentsInIls } from '../fn/ils/ils-controller-count-students-in-ils';
import { IlsControllerCountStudentsInIls$Params } from '../fn/ils/ils-controller-count-students-in-ils';
import { ilsControllerCreateStudent } from '../fn/ils/ils-controller-create-student';
import { IlsControllerCreateStudent$Params } from '../fn/ils/ils-controller-create-student';
import { ilsControllerDuplicateContentToIls } from '../fn/ils/ils-controller-duplicate-content-to-ils';
import { IlsControllerDuplicateContentToIls$Params } from '../fn/ils/ils-controller-duplicate-content-to-ils';
import { ilsControllerDuplicateIls } from '../fn/ils/ils-controller-duplicate-ils';
import { IlsControllerDuplicateIls$Params } from '../fn/ils/ils-controller-duplicate-ils';
import { ilsControllerDuplicatePhaseToIls } from '../fn/ils/ils-controller-duplicate-phase-to-ils';
import { IlsControllerDuplicatePhaseToIls$Params } from '../fn/ils/ils-controller-duplicate-phase-to-ils';
import { ilsControllerExportIls } from '../fn/ils/ils-controller-export-ils';
import { IlsControllerExportIls$Params } from '../fn/ils/ils-controller-export-ils';
import { ilsControllerFindFastIlsById } from '../fn/ils/ils-controller-find-fast-ils-by-id';
import { IlsControllerFindFastIlsById$Params } from '../fn/ils/ils-controller-find-fast-ils-by-id';
import { ilsControllerFindIlsDescription } from '../fn/ils/ils-controller-find-ils-description';
import { IlsControllerFindIlsDescription$Params } from '../fn/ils/ils-controller-find-ils-description';
import { ilsControllerFindIlssByAppId } from '../fn/ils/ils-controller-find-ilss-by-app-id';
import { IlsControllerFindIlssByAppId$Params } from '../fn/ils/ils-controller-find-ilss-by-app-id';
import { ilsControllerFindIlssByLabId } from '../fn/ils/ils-controller-find-ilss-by-lab-id';
import { IlsControllerFindIlssByLabId$Params } from '../fn/ils/ils-controller-find-ilss-by-lab-id';
import { ilsControllerFindIlsWithContent } from '../fn/ils/ils-controller-find-ils-with-content';
import { IlsControllerFindIlsWithContent$Params } from '../fn/ils/ils-controller-find-ils-with-content';
import { ilsControllerFindIlsWithContentAndNames } from '../fn/ils/ils-controller-find-ils-with-content-and-names';
import { IlsControllerFindIlsWithContentAndNames$Params } from '../fn/ils/ils-controller-find-ils-with-content-and-names';
import { ilsControllerGetAllFastIlsInfos } from '../fn/ils/ils-controller-get-all-fast-ils-infos';
import { IlsControllerGetAllFastIlsInfos$Params } from '../fn/ils/ils-controller-get-all-fast-ils-infos';
import { ilsControllerGetAllGroups } from '../fn/ils/ils-controller-get-all-groups';
import { IlsControllerGetAllGroups$Params } from '../fn/ils/ils-controller-get-all-groups';
import { ilsControllerGetAllSlowIlsInfos } from '../fn/ils/ils-controller-get-all-slow-ils-infos';
import { IlsControllerGetAllSlowIlsInfos$Params } from '../fn/ils/ils-controller-get-all-slow-ils-infos';
import { ilsControllerGetAllStudentInfos } from '../fn/ils/ils-controller-get-all-student-infos';
import { IlsControllerGetAllStudentInfos$Params } from '../fn/ils/ils-controller-get-all-student-infos';
import { ilsControllerGetAllStudents } from '../fn/ils/ils-controller-get-all-students';
import { IlsControllerGetAllStudents$Params } from '../fn/ils/ils-controller-get-all-students';
import { ilsControllerGetSecrets } from '../fn/ils/ils-controller-get-secrets';
import { IlsControllerGetSecrets$Params } from '../fn/ils/ils-controller-get-secrets';
import { ilsControllerImportIls } from '../fn/ils/ils-controller-import-ils';
import { IlsControllerImportIls$Params } from '../fn/ils/ils-controller-import-ils';
import { ilsControllerMoveContentToOtherPhase } from '../fn/ils/ils-controller-move-content-to-other-phase';
import { IlsControllerMoveContentToOtherPhase$Params } from '../fn/ils/ils-controller-move-content-to-other-phase';
import { ilsControllerRemoveContentFromIls } from '../fn/ils/ils-controller-remove-content-from-ils';
import { IlsControllerRemoveContentFromIls$Params } from '../fn/ils/ils-controller-remove-content-from-ils';
import { ilsControllerRemovePhaseFromIls } from '../fn/ils/ils-controller-remove-phase-from-ils';
import { IlsControllerRemovePhaseFromIls$Params } from '../fn/ils/ils-controller-remove-phase-from-ils';
import { ilsControllerRemoveStudent } from '../fn/ils/ils-controller-remove-student';
import { IlsControllerRemoveStudent$Params } from '../fn/ils/ils-controller-remove-student';
import { ilsControllerReorderContentList } from '../fn/ils/ils-controller-reorder-content-list';
import { IlsControllerReorderContentList$Params } from '../fn/ils/ils-controller-reorder-content-list';
import { ilsControllerReorderPhaseList } from '../fn/ils/ils-controller-reorder-phase-list';
import { IlsControllerReorderPhaseList$Params } from '../fn/ils/ils-controller-reorder-phase-list';
import { ilsControllerSetGroups } from '../fn/ils/ils-controller-set-groups';
import { IlsControllerSetGroups$Params } from '../fn/ils/ils-controller-set-groups';
import { ilsControllerStudentLogin } from '../fn/ils/ils-controller-student-login';
import { IlsControllerStudentLogin$Params } from '../fn/ils/ils-controller-student-login';
import { ilsControllerUpdate } from '../fn/ils/ils-controller-update';
import { IlsControllerUpdate$Params } from '../fn/ils/ils-controller-update';
import { ilsControllerUpdateMetadata } from '../fn/ils/ils-controller-update-metadata';
import { IlsControllerUpdateMetadata$Params } from '../fn/ils/ils-controller-update-metadata';
import { ilsControllerUpdateOwnerAndViewerList } from '../fn/ils/ils-controller-update-owner-and-viewer-list';
import { IlsControllerUpdateOwnerAndViewerList$Params } from '../fn/ils/ils-controller-update-owner-and-viewer-list';
import { ilsControllerUpdateSecrets } from '../fn/ils/ils-controller-update-secrets';
import { IlsControllerUpdateSecrets$Params } from '../fn/ils/ils-controller-update-secrets';
import { ilsControllerUpdateStudentNickname } from '../fn/ils/ils-controller-update-student-nickname';
import { IlsControllerUpdateStudentNickname$Params } from '../fn/ils/ils-controller-update-student-nickname';
import { IlsDescription } from '../models/ils-description';
import { IlsForExport } from '../models/ils-for-export';
import { IlsWithContent } from '../models/ils-with-content';
import { IlsWithContentAndNames } from '../models/ils-with-content-and-names';
import { OwnerAndViewerList } from '../models/owner-and-viewer-list';
import { PhaseWithContent } from '../models/phase-with-content';
import { Secret } from '../models/secret';
import { SlowIlsInfo } from '../models/slow-ils-info';
import { StoredGroup } from '../models/stored-group';
import { Student } from '../models/student';
import { StudentCount } from '../models/student-count';
import { StudentInfo } from '../models/student-info';
import { StudentToken } from '../models/student-token';

@Injectable({ providedIn: 'root' })
export class IlsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ilsControllerGetAllFastIlsInfos()` */
  static readonly IlsControllerGetAllFastIlsInfosPath = '/ils/listAllFast';

  /**
   * Get the list of all fast ils infos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerGetAllFastIlsInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllFastIlsInfos$Response(params?: IlsControllerGetAllFastIlsInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FastIlsInfo>>> {
    const obs = ilsControllerGetAllFastIlsInfos(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all fast ils infos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerGetAllFastIlsInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllFastIlsInfos(params?: IlsControllerGetAllFastIlsInfos$Params, context?: HttpContext): Observable<Array<FastIlsInfo>> {
    const resp = this.ilsControllerGetAllFastIlsInfos$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FastIlsInfo>>): Array<FastIlsInfo> => r.body)
    );
  }

  /** Path part for operation `ilsControllerFindFastIlsById()` */
  static readonly IlsControllerFindFastIlsByIdPath = '/ils/{ilsId}/findFastIlsById';

  /**
   * Get the fast ils info by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerFindFastIlsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindFastIlsById$Response(params: IlsControllerFindFastIlsById$Params, context?: HttpContext): Observable<StrictHttpResponse<FastIlsInfo>> {
    const obs = ilsControllerFindFastIlsById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the fast ils info by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerFindFastIlsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindFastIlsById(params: IlsControllerFindFastIlsById$Params, context?: HttpContext): Observable<FastIlsInfo> {
    const resp = this.ilsControllerFindFastIlsById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FastIlsInfo>): FastIlsInfo => r.body)
    );
  }

  /** Path part for operation `ilsControllerGetAllSlowIlsInfos()` */
  static readonly IlsControllerGetAllSlowIlsInfosPath = '/ils/listAllSlow/{getDataSize}';

  /**
   * Get the list of all slow ils infos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerGetAllSlowIlsInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllSlowIlsInfos$Response(params: IlsControllerGetAllSlowIlsInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SlowIlsInfo>>> {
    const obs = ilsControllerGetAllSlowIlsInfos(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all slow ils infos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerGetAllSlowIlsInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllSlowIlsInfos(params: IlsControllerGetAllSlowIlsInfos$Params, context?: HttpContext): Observable<Array<SlowIlsInfo>> {
    const resp = this.ilsControllerGetAllSlowIlsInfos$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SlowIlsInfo>>): Array<SlowIlsInfo> => r.body)
    );
  }

  /** Path part for operation `ilsControllerFindIlsWithContent()` */
  static readonly IlsControllerFindIlsWithContentPath = '/ils/{ilsId}/content';

  /**
   * Get an ils with all content.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerFindIlsWithContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlsWithContent$Response(params: IlsControllerFindIlsWithContent$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsWithContent>> {
    const obs = ilsControllerFindIlsWithContent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an ils with all content.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerFindIlsWithContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlsWithContent(params: IlsControllerFindIlsWithContent$Params, context?: HttpContext): Observable<IlsWithContent> {
    const resp = this.ilsControllerFindIlsWithContent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<IlsWithContent>): IlsWithContent => r.body)
    );
  }

  /** Path part for operation `ilsControllerAddContentToIls()` */
  static readonly IlsControllerAddContentToIlsPath = '/ils/{ilsId}/content';

  /**
   * Create new content and add it to an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerAddContentToIls()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerAddContentToIls$Response(params: IlsControllerAddContentToIls$Params, context?: HttpContext): Observable<StrictHttpResponse<Content>> {
    const obs = ilsControllerAddContentToIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create new content and add it to an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerAddContentToIls$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerAddContentToIls(params: IlsControllerAddContentToIls$Params, context?: HttpContext): Observable<Content> {
    const resp = this.ilsControllerAddContentToIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Content>): Content => r.body)
    );
  }

  /** Path part for operation `ilsControllerFindIlsWithContentAndNames()` */
  static readonly IlsControllerFindIlsWithContentAndNamesPath = '/ils/{ilsId}/contentAndNames';

  /**
   * Get an ils with all content and names.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerFindIlsWithContentAndNames()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlsWithContentAndNames$Response(params: IlsControllerFindIlsWithContentAndNames$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsWithContentAndNames>> {
    const obs = ilsControllerFindIlsWithContentAndNames(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an ils with all content and names.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerFindIlsWithContentAndNames$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlsWithContentAndNames(params: IlsControllerFindIlsWithContentAndNames$Params, context?: HttpContext): Observable<IlsWithContentAndNames> {
    const resp = this.ilsControllerFindIlsWithContentAndNames$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<IlsWithContentAndNames>): IlsWithContentAndNames => r.body)
    );
  }

  /** Path part for operation `ilsControllerFindIlsDescription()` */
  static readonly IlsControllerFindIlsDescriptionPath = '/ils/{ilsId}/description';

  /**
   * Get an ils description.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerFindIlsDescription()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlsDescription$Response(params: IlsControllerFindIlsDescription$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsDescription>> {
    const obs = ilsControllerFindIlsDescription(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an ils description.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerFindIlsDescription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlsDescription(params: IlsControllerFindIlsDescription$Params, context?: HttpContext): Observable<IlsDescription> {
    const resp = this.ilsControllerFindIlsDescription$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<IlsDescription>): IlsDescription => r.body)
    );
  }

  /** Path part for operation `ilsControllerUpdate()` */
  static readonly IlsControllerUpdatePath = '/ils/{ilsId}';

  /**
   * Update an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdate$Response(params: IlsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Ils>> {
    const obs = ilsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdate(params: IlsControllerUpdate$Params, context?: HttpContext): Observable<Ils> {
    const resp = this.ilsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Ils>): Ils => r.body)
    );
  }

  /** Path part for operation `ilsControllerUpdateMetadata()` */
  static readonly IlsControllerUpdateMetadataPath = '/ils/{ilsId}/metadata';

  /**
   * Update the metadata of an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerUpdateMetadata()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateMetadata$Response(params: IlsControllerUpdateMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<Ils>> {
    const obs = ilsControllerUpdateMetadata(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update the metadata of an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerUpdateMetadata$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateMetadata(params: IlsControllerUpdateMetadata$Params, context?: HttpContext): Observable<Ils> {
    const resp = this.ilsControllerUpdateMetadata$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Ils>): Ils => r.body)
    );
  }

  /** Path part for operation `ilsControllerAddPhaseToIls()` */
  static readonly IlsControllerAddPhaseToIlsPath = '/ils/{ilsId}/phase';

  /**
   * Create new phase and add it to an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerAddPhaseToIls()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerAddPhaseToIls$Response(params: IlsControllerAddPhaseToIls$Params, context?: HttpContext): Observable<StrictHttpResponse<PhaseWithContent>> {
    const obs = ilsControllerAddPhaseToIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create new phase and add it to an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerAddPhaseToIls$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerAddPhaseToIls(params: IlsControllerAddPhaseToIls$Params, context?: HttpContext): Observable<PhaseWithContent> {
    const resp = this.ilsControllerAddPhaseToIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PhaseWithContent>): PhaseWithContent => r.body)
    );
  }

  /** Path part for operation `ilsControllerDuplicatePhaseToIls()` */
  static readonly IlsControllerDuplicatePhaseToIlsPath = '/ils/{ilsId}/{sourcePhaseId}/duplicate';

  /**
   * Duplicate existing phase and add it to an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerDuplicatePhaseToIls()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerDuplicatePhaseToIls$Response(params: IlsControllerDuplicatePhaseToIls$Params, context?: HttpContext): Observable<StrictHttpResponse<PhaseWithContent>> {
    const obs = ilsControllerDuplicatePhaseToIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Duplicate existing phase and add it to an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerDuplicatePhaseToIls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerDuplicatePhaseToIls(params: IlsControllerDuplicatePhaseToIls$Params, context?: HttpContext): Observable<PhaseWithContent> {
    const resp = this.ilsControllerDuplicatePhaseToIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PhaseWithContent>): PhaseWithContent => r.body)
    );
  }

  /** Path part for operation `ilsControllerRemovePhaseFromIls()` */
  static readonly IlsControllerRemovePhaseFromIlsPath = '/ils/{ilsId}/phase/{phaseId}';

  /**
   * Delete a phase from an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerRemovePhaseFromIls()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerRemovePhaseFromIls$Response(params: IlsControllerRemovePhaseFromIls$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = ilsControllerRemovePhaseFromIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a phase from an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerRemovePhaseFromIls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerRemovePhaseFromIls(params: IlsControllerRemovePhaseFromIls$Params, context?: HttpContext): Observable<void> {
    const resp = this.ilsControllerRemovePhaseFromIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ilsControllerDuplicateIls()` */
  static readonly IlsControllerDuplicateIlsPath = '/ils/{ilsId}/duplicate/{destinationFolderId}';

  /**
   * Duplicate existing ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerDuplicateIls()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerDuplicateIls$Response(params: IlsControllerDuplicateIls$Params, context?: HttpContext): Observable<StrictHttpResponse<FastIlsInfo>> {
    const obs = ilsControllerDuplicateIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Duplicate existing ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerDuplicateIls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerDuplicateIls(params: IlsControllerDuplicateIls$Params, context?: HttpContext): Observable<FastIlsInfo> {
    const resp = this.ilsControllerDuplicateIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FastIlsInfo>): FastIlsInfo => r.body)
    );
  }

  /** Path part for operation `ilsControllerDuplicateContentToIls()` */
  static readonly IlsControllerDuplicateContentToIlsPath = '/ils/{ilsId}/{phaseId}/{sourceContentId}/duplicate';

  /**
   * Duplicate existing content and add it to an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerDuplicateContentToIls()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerDuplicateContentToIls$Response(params: IlsControllerDuplicateContentToIls$Params, context?: HttpContext): Observable<StrictHttpResponse<Content>> {
    const obs = ilsControllerDuplicateContentToIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Duplicate existing content and add it to an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerDuplicateContentToIls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerDuplicateContentToIls(params: IlsControllerDuplicateContentToIls$Params, context?: HttpContext): Observable<Content> {
    const resp = this.ilsControllerDuplicateContentToIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Content>): Content => r.body)
    );
  }

  /** Path part for operation `ilsControllerMoveContentToOtherPhase()` */
  static readonly IlsControllerMoveContentToOtherPhasePath = '/ils/{ilsId}/{phaseId}/{contentId}/move';

  /**
   * Move existing content to another phase in an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerMoveContentToOtherPhase()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerMoveContentToOtherPhase$Response(params: IlsControllerMoveContentToOtherPhase$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = ilsControllerMoveContentToOtherPhase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Move existing content to another phase in an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerMoveContentToOtherPhase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerMoveContentToOtherPhase(params: IlsControllerMoveContentToOtherPhase$Params, context?: HttpContext): Observable<void> {
    const resp = this.ilsControllerMoveContentToOtherPhase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ilsControllerRemoveContentFromIls()` */
  static readonly IlsControllerRemoveContentFromIlsPath = '/ils/{ilsId}/content/{contentId}';

  /**
   * Delete a content from an ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerRemoveContentFromIls()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerRemoveContentFromIls$Response(params: IlsControllerRemoveContentFromIls$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = ilsControllerRemoveContentFromIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a content from an ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerRemoveContentFromIls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerRemoveContentFromIls(params: IlsControllerRemoveContentFromIls$Params, context?: HttpContext): Observable<void> {
    const resp = this.ilsControllerRemoveContentFromIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ilsControllerReorderContentList()` */
  static readonly IlsControllerReorderContentListPath = '/ils/{ilsId}/contentList';

  /**
   * Update the order of the content elements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerReorderContentList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerReorderContentList$Response(params: IlsControllerReorderContentList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Content>>> {
    const obs = ilsControllerReorderContentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update the order of the content elements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerReorderContentList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerReorderContentList(params: IlsControllerReorderContentList$Params, context?: HttpContext): Observable<Array<Content>> {
    const resp = this.ilsControllerReorderContentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Content>>): Array<Content> => r.body)
    );
  }

  /** Path part for operation `ilsControllerReorderPhaseList()` */
  static readonly IlsControllerReorderPhaseListPath = '/ils/{ilsId}/phaseList';

  /**
   * Update the order of the phase elements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerReorderPhaseList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerReorderPhaseList$Response(params: IlsControllerReorderPhaseList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PhaseWithContent>>> {
    const obs = ilsControllerReorderPhaseList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update the order of the phase elements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerReorderPhaseList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerReorderPhaseList(params: IlsControllerReorderPhaseList$Params, context?: HttpContext): Observable<Array<PhaseWithContent>> {
    const resp = this.ilsControllerReorderPhaseList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PhaseWithContent>>): Array<PhaseWithContent> => r.body)
    );
  }

  /** Path part for operation `ilsControllerStudentLogin()` */
  static readonly IlsControllerStudentLoginPath = '/ils/{ilsId}/login';

  /**
   * Student login, creates a new student if not known.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerStudentLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerStudentLogin$Response(params: IlsControllerStudentLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentToken>> {
    const obs = ilsControllerStudentLogin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Student login, creates a new student if not known.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerStudentLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerStudentLogin(params: IlsControllerStudentLogin$Params, context?: HttpContext): Observable<StudentToken> {
    const resp = this.ilsControllerStudentLogin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentToken>): StudentToken => r.body)
    );
  }

  /** Path part for operation `ilsControllerRemoveStudent()` */
  static readonly IlsControllerRemoveStudentPath = '/ils/{ilsId}/removeStudent/{studentId}';

  /**
   * Remove student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerRemoveStudent()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerRemoveStudent$Response(params: IlsControllerRemoveStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = ilsControllerRemoveStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerRemoveStudent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerRemoveStudent(params: IlsControllerRemoveStudent$Params, context?: HttpContext): Observable<void> {
    const resp = this.ilsControllerRemoveStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ilsControllerCreateStudent()` */
  static readonly IlsControllerCreateStudentPath = '/ils/{ilsId}/createStudent';

  /**
   * Creates a new student if not known.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerCreateStudent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerCreateStudent$Response(params: IlsControllerCreateStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<Student>> {
    const obs = ilsControllerCreateStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new student if not known.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerCreateStudent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerCreateStudent(params: IlsControllerCreateStudent$Params, context?: HttpContext): Observable<Student> {
    const resp = this.ilsControllerCreateStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Student>): Student => r.body)
    );
  }

  /** Path part for operation `ilsControllerUpdateStudentNickname()` */
  static readonly IlsControllerUpdateStudentNicknamePath = '/ils/{ilsId}/student/{studentId}/nickname';

  /**
   * Update a student nickname.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerUpdateStudentNickname()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateStudentNickname$Response(params: IlsControllerUpdateStudentNickname$Params, context?: HttpContext): Observable<StrictHttpResponse<Student>> {
    const obs = ilsControllerUpdateStudentNickname(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a student nickname.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerUpdateStudentNickname$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateStudentNickname(params: IlsControllerUpdateStudentNickname$Params, context?: HttpContext): Observable<Student> {
    const resp = this.ilsControllerUpdateStudentNickname$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Student>): Student => r.body)
    );
  }

  /** Path part for operation `ilsControllerGetAllStudents()` */
  static readonly IlsControllerGetAllStudentsPath = '/ils/{ilsId}/students';

  /**
   * Get the list of all students.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerGetAllStudents()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllStudents$Response(params: IlsControllerGetAllStudents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Student>>> {
    const obs = ilsControllerGetAllStudents(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all students.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerGetAllStudents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllStudents(params: IlsControllerGetAllStudents$Params, context?: HttpContext): Observable<Array<Student>> {
    const resp = this.ilsControllerGetAllStudents$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Student>>): Array<Student> => r.body)
    );
  }

  /** Path part for operation `ilsControllerGetAllStudentInfos()` */
  static readonly IlsControllerGetAllStudentInfosPath = '/ils/{ilsId}/studentInfos';

  /**
   * Get the list of all infos from students.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerGetAllStudentInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllStudentInfos$Response(params: IlsControllerGetAllStudentInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StudentInfo>>> {
    const obs = ilsControllerGetAllStudentInfos(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all infos from students.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerGetAllStudentInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllStudentInfos(params: IlsControllerGetAllStudentInfos$Params, context?: HttpContext): Observable<Array<StudentInfo>> {
    const resp = this.ilsControllerGetAllStudentInfos$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<StudentInfo>>): Array<StudentInfo> => r.body)
    );
  }

  /** Path part for operation `ilsControllerGetAllGroups()` */
  static readonly IlsControllerGetAllGroupsPath = '/ils/{ilsId}/groups';

  /**
   * Get the list of all groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerGetAllGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllGroups$Response(params: IlsControllerGetAllGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupsInfo>> {
    const obs = ilsControllerGetAllGroups(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerGetAllGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetAllGroups(params: IlsControllerGetAllGroups$Params, context?: HttpContext): Observable<GroupsInfo> {
    const resp = this.ilsControllerGetAllGroups$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GroupsInfo>): GroupsInfo => r.body)
    );
  }

  /** Path part for operation `ilsControllerSetGroups()` */
  static readonly IlsControllerSetGroupsPath = '/ils/{ilsId}/groups';

  /**
   * sets the groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerSetGroups()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerSetGroups$Response(params: IlsControllerSetGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StoredGroup>>> {
    const obs = ilsControllerSetGroups(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * sets the groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerSetGroups$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerSetGroups(params: IlsControllerSetGroups$Params, context?: HttpContext): Observable<Array<StoredGroup>> {
    const resp = this.ilsControllerSetGroups$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<StoredGroup>>): Array<StoredGroup> => r.body)
    );
  }

  /** Path part for operation `ilsControllerUpdateOwnerAndViewerList()` */
  static readonly IlsControllerUpdateOwnerAndViewerListPath = '/ils/{ilsId}/sharing';

  /**
   * Update the owner and viewer list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerUpdateOwnerAndViewerList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateOwnerAndViewerList$Response(params: IlsControllerUpdateOwnerAndViewerList$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerAndViewerList>> {
    const obs = ilsControllerUpdateOwnerAndViewerList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update the owner and viewer list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerUpdateOwnerAndViewerList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateOwnerAndViewerList(params: IlsControllerUpdateOwnerAndViewerList$Params, context?: HttpContext): Observable<OwnerAndViewerList> {
    const resp = this.ilsControllerUpdateOwnerAndViewerList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OwnerAndViewerList>): OwnerAndViewerList => r.body)
    );
  }

  /** Path part for operation `ilsControllerCountStudentsInIls()` */
  static readonly IlsControllerCountStudentsInIlsPath = '/ils/{ilsId}/studentCount';

  /**
   * Get student count.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerCountStudentsInIls()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerCountStudentsInIls$Response(params: IlsControllerCountStudentsInIls$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentCount>> {
    const obs = ilsControllerCountStudentsInIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get student count.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerCountStudentsInIls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerCountStudentsInIls(params: IlsControllerCountStudentsInIls$Params, context?: HttpContext): Observable<StudentCount> {
    const resp = this.ilsControllerCountStudentsInIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentCount>): StudentCount => r.body)
    );
  }

  /** Path part for operation `ilsControllerGetSecrets()` */
  static readonly IlsControllerGetSecretsPath = '/ils/{ilsId}/secrets';

  /**
   * Get ILS secrets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerGetSecrets()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetSecrets$Response(params: IlsControllerGetSecrets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Secret>>> {
    const obs = ilsControllerGetSecrets(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get ILS secrets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerGetSecrets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerGetSecrets(params: IlsControllerGetSecrets$Params, context?: HttpContext): Observable<Array<Secret>> {
    const resp = this.ilsControllerGetSecrets$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Secret>>): Array<Secret> => r.body)
    );
  }

  /** Path part for operation `ilsControllerUpdateSecrets()` */
  static readonly IlsControllerUpdateSecretsPath = '/ils/{ilsId}/secrets';

  /**
   * Update ils secrets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerUpdateSecrets()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateSecrets$Response(params: IlsControllerUpdateSecrets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = ilsControllerUpdateSecrets(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update ils secrets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerUpdateSecrets$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerUpdateSecrets(params: IlsControllerUpdateSecrets$Params, context?: HttpContext): Observable<void> {
    const resp = this.ilsControllerUpdateSecrets$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ilsControllerExportIls()` */
  static readonly IlsControllerExportIlsPath = '/ils/{ilsId}/export';

  /**
   * Export the ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerExportIls()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerExportIls$Response(params: IlsControllerExportIls$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsForExport>> {
    const obs = ilsControllerExportIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Export the ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerExportIls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerExportIls(params: IlsControllerExportIls$Params, context?: HttpContext): Observable<IlsForExport> {
    const resp = this.ilsControllerExportIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<IlsForExport>): IlsForExport => r.body)
    );
  }

  /** Path part for operation `ilsControllerImportIls()` */
  static readonly IlsControllerImportIlsPath = '/ils/{folderId}/import';

  /**
   * Import an exported ils.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerImportIls()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerImportIls$Response(params: IlsControllerImportIls$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = ilsControllerImportIls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Import an exported ils.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerImportIls$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ilsControllerImportIls(params: IlsControllerImportIls$Params, context?: HttpContext): Observable<string> {
    const resp = this.ilsControllerImportIls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `ilsControllerFindIlssByAppId()` */
  static readonly IlsControllerFindIlssByAppIdPath = '/ils/app/{appId}';

  /**
   * Get ils by app id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerFindIlssByAppId()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlssByAppId$Response(params: IlsControllerFindIlssByAppId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Ils>>> {
    const obs = ilsControllerFindIlssByAppId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get ils by app id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerFindIlssByAppId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlssByAppId(params: IlsControllerFindIlssByAppId$Params, context?: HttpContext): Observable<Array<Ils>> {
    const resp = this.ilsControllerFindIlssByAppId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Ils>>): Array<Ils> => r.body)
    );
  }

  /** Path part for operation `ilsControllerFindIlssByLabId()` */
  static readonly IlsControllerFindIlssByLabIdPath = '/ils/lab/{labId}';

  /**
   * Get ils by lab id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ilsControllerFindIlssByLabId()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlssByLabId$Response(params: IlsControllerFindIlssByLabId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Ils>>> {
    const obs = ilsControllerFindIlssByLabId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get ils by lab id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ilsControllerFindIlssByLabId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ilsControllerFindIlssByLabId(params: IlsControllerFindIlssByLabId$Params, context?: HttpContext): Observable<Array<Ils>> {
    const resp = this.ilsControllerFindIlssByLabId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Ils>>): Array<Ils> => r.body)
    );
  }

}
